<template>
  <div class="blog-page blog-page-posts-show">
    <div v-if="loading">
      <div class="progress">
        <div class="indeterminate" />
      </div>
      <div class="blog-page--hero">
        <h1 class="blog-page--page-title bg-cl-secondary brdr-radius-20 h-44 mb5" />
        <h1 class="blog-page--page-title bg-cl-secondary brdr-radius-20 h-44 mw-550" />
        <h3 class="blog-page--page-title blog-page--preview-date bg-cl-secondary brdr-radius-20 h-16 mw-200" />
        <div class="container">
          <div class="blog-page--preview-large bg-cl-secondary brdr-radius-20" />
        </div>
        <div class="container bg-cl-secondary brdr-radius-20 mt20 h-16" />
        <div class="container bg-cl-secondary brdr-radius-20 mt20 h-16" />
      </div>
    </div>
    <div v-else-if="post">
      <div class="container">
        <breadcrumbs
          :routes="[{name: 'Home', route_link: '/'},{name: 'Porady', route_link: '/porady'}]"
          :active-route="post.title"
        />
      </div>
      <!-- Article rich snippet -->
      <div class="hidden" itemscope itemtype="https://schema.org/Article">
        <span itemprop="author" :content="post.author.node.name" />
        <span itemprop="datePublished">{{ post.date }}</span>
        <span itemprop="dateModified">{{ post.modified }}</span>
        <span itemprop="headline" v-html="post.title" />
        <span itemprop="image" :content="post.featuredImage.node.sourceUrl" />
        <span itemprop="publisher" itemtype="http://schema.org/Organization" itemscope>
          <span itemprop="name" content="Agrosimex.pl" />
          <span itemprop="logo" itemscope itemtype="https://schema.org/ImageObject">
            <img :src="hostName + '/assets/android-icon-72x72.png'" alt="agrosimex logo" itemprop="contentUrl">
            <span itemprop="url" :content="hostName" />
          </span>
        </span>
      </div>
      <!-- rich snippet end -->
      <div class="blog-page--hero">
        <h1 class="blog-page--page-title" v-html="post.title" />
        <h3 class="blog-page--page-date blog-page--preview-date">
          {{ post.date | prettyDate }}
        </h3>
      </div>
      <div class="container">
        <div class="blog-page--preview-large blog-page--preview-large-hero-merge" :style="getPostImage(post)" />
      </div>
      <div class="blog-page--post-container">
        <div class="container" v-html="post.content" />
        <div class="container">
          <router-link :to="localizedRoute(`/porady`)" class="link blog-page--preview-link">
            {{ $t('Back to posts') }}
          </router-link>
        </div>
      </div>
      <div class="blog-page--entries" v-if="relatedPosts">
        <div class="container">
          <h2>
            {{ $t('Related Posts') }}
          </h2>
          <div class="row row--entries">
            <div class="col col-md-6 col-lg-4" v-for="(post) in relatedPosts" :key="post.id">
              <div class="blog-page--preview-small">
                <router-link :to="localizedRoute(`/porady/${post.slug}`)" class="blog-page--preview-small-bg" :style="getPostImage(post)">
                  &nbsp;
                </router-link>
                <div class="blog-page--preview-small-inner">
                  <h4 class="blog-page--preview-date">
                    {{ post.date | prettyDate }}
                  </h4>
                  <h3 class="blog-page--preview-title">
                    <router-link :to="localizedRoute(`/porady/${post.slug}`)" v-html="post.title" />
                  </h3>
                  <p class="blog-page--preview-excerpt" v-html="sanitizeHtml(post.excerpt)" />
                  <router-link :to="localizedRoute(`/porady/${post.slug}`)" class="blog-page--preview-link">
                    {{ $t('Learn More') }}&nbsp;<span class="slide-right">&rtrif;</span>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <h2>
        {{ $t('No post found.') }}
      </h2>
    </div>
  </div>
</template>

<script>
import Show from 'src/modules/vsf-wordpress/components/posts/Show.js'
import config from 'config'

export default {
  mixins: [Show],
  name: 'PostsShow',
  computed: {
    hostName () {
      return config.server.hostName
    }
  }
}
</script>

<style>
.blog-page-posts-show img {
  max-width: 100%;
  height: auto;
}
</style>
<style lang="scss" scoped>
@import 'src/modules/vsf-wordpress/components/blog/scss/blog';

.blog-page-posts-show {
  background: $white-smoke;
  .blog-page--hero {
    background: #F5F5F5;
    padding-top: 100px;
    padding-bottom: 200px;
    @media (max-width: 767px) {
      padding-top: 0px;
    }
  }

  .blog-page--page-title {
    display: block;
    text-align: center;
    color: $nearly-black;
    margin: 0 auto 30px;
    max-width: 650px;
  }

  .blog-page--page-date.blog-page--page-date {
    display: block;
    text-align: center;
    color: $nearly-black;
    font-size: 16px;
    margin: 20px auto 10px;
    font-weight: 400;
  }

  .blog-page--preview-large {
    margin-bottom: 0;
    &:before {
      display: none;
    }
  }

  .blog-page--post-container {
    padding: 20px;
    background-color: $white-smoke;
    h3 {
      color: $nearly-black;
      margin: 20px 0;
    }
    p {
      font-family: $PTSans;
      margin: 0 0 40px;
      font-size: 19px;
      line-height: 1.65;
      color: #444;

    }
    p + h3 {
      margin-top: 20px * 2;
    }
    img {
      box-shadow: 0 2px 10px 1px rgba(65, 64, 64, 0.2);
      border-radius: 5px;
      margin: 20px 0 30px;
    }
  }
  .blog-page--entries {
    padding: 60px 0 20px;
    background: #f9f9f9;
    h2 {
      margin-top: 0;
      margin-bottom: 30px;
      text-align: center;
    }
  }
}
  .h-44 {
    height: 44px;
  }
  .h-16 {
    height: 16px;
  }
  .mw-550 {
    max-width: 550px !important;
  }
  .mw-200 {
    max-width: 200px !important;
  }
/* Progress Bar */
.progress {
  position: relative;
  height: 4px;
  display: block;
  width: 100%;
  background-color: #18357b;
  border-radius: 2px;
  background-clip: padding-box;
  margin: 5px 0 0 0;
  overflow: hidden;
}
  .progress .determinate {
    position: absolute;
    background-color: inherit;
    top: 0;
    bottom: 0;
    background-color: #041D59;
    transition: width .3s linear;
  }
  .progress .indeterminate {
    background-color: #041D59;
  }
    .progress .indeterminate:before {
      content: '';
      position: absolute;
      background-color: inherit;
      top: 0;
      left: 0;
      bottom: 0;
      will-change: left, right;
      -webkit-animation: indeterminate 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
              animation: indeterminate 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
  }
  .progress .indeterminate:after {
      content: '';
      position: absolute;
      background-color: inherit;
      top: 0;
      left: 0;
      bottom: 0;
      will-change: left, right;
      -webkit-animation: indeterminate-short 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
              animation: indeterminate-short 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
      -webkit-animation-delay: 1.15s;
              animation-delay: 1.15s;
  }

  @-webkit-keyframes indeterminate {
    0% {
      left: -35%;
      right: 100%; }
    60% {
      left: 100%;
      right: -90%; }
    100% {
      left: 100%;
      right: -90%; } }
  @keyframes indeterminate {
    0% {
      left: -35%;
      right: 100%; }
    60% {
      left: 100%;
      right: -90%; }
    100% {
      left: 100%;
      right: -90%; } }
  @-webkit-keyframes indeterminate-short {
    0% {
      left: -200%;
      right: 100%; }
    60% {
      left: 107%;
      right: -8%; }
    100% {
      left: 107%;
      right: -8%; } }
  @keyframes indeterminate-short {
    0% {
      left: -200%;
      right: 100%; }
    60% {
      left: 107%;
      right: -8%; }
    100% {
      left: 107%;
      right: -8%;
    }
  }
</style>
